import { Icon } from "../icon";
import type { IProps } from "./dropdown-icon.types";
import { forwardRef } from "react";
import { faChevronUp } from "@fortawesome/pro-solid-svg-icons";

const DropdownIcon = forwardRef<HTMLDivElement, IProps>(function DropdownIcon({ isOpen, ...otherProps }, ref) {
    return <Icon ref={ref} size="xxs" rotation={isOpen ? undefined : 180} icon={faChevronUp} {...otherProps} />;
});

export { DropdownIcon };
